import {
  FETCH_PACKAGE_ADDONS_REQUEST,
  FETCH_USER_ADDONS_REQUEST,
  FETCH_PREMIUM_ADDONS_SUCCESS,
  FETCH_PREMIUM_ADDONS_FAILURE,
  FETCH_DEVICE_ADDONS_SUCCESS,
  FETCH_DEVICE_ADDONS_FAILURE,
  FETCH_ADDON_REQUEST,
  FETCH_ADDON_DETAILS_SUCCESS,
  FETCH_ADDON_VIDEOS_SUCCESS,
  FETCH_ADDON_VIDEOS_FAILURE,
  SELECT_ADDON_SUCCESS,
  SELECT_ADDON_FAILURE,
  FOCUS_ADDON,
  FOCUS_DETAILS,
  DISMISS_ERROR,
  RESET,
  REMOVE_ADDON_REQUEST
} from '../actions/addons'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'
import { FETCH_CART_ITEMS_SUCCESS } from '../actions/cart'
import { PAY_NOW_SUCCESS } from '../actions/checkout'
import { SELECT_PACKAGE_SUCCESS } from '../actions/packages'

const INITIAL_STATE = {
  addons: [],
  isReady: false,
  hasError: false,
  errorMessage: '',
  previousAddonPos: -1,
  focusedAddonPos: -1,
  focusDetails: false,
}

const addonsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PACKAGE_ADDONS_REQUEST:
    case FETCH_USER_ADDONS_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: '',
        addons: [],
      }
    case FETCH_PREMIUM_ADDONS_SUCCESS:
      const newAddons = [...state.addons, ...action.payload.addons]
      const focusedAddonPos = newAddons.findIndex(
        addon => addon.id === action.payload.focusedChannelId
      )
      return {
        ...state,
        isReady: true,
        hasError: false,
        errorMessage: '',
        addons: newAddons,
        focusedAddonPos:
          focusedAddonPos === -1 ? (newAddons.length > 0 ? 0 : -1) : focusedAddonPos,
        previousAddonPos:
          focusedAddonPos === -1 ? (newAddons.length > 0 ? 0 : -1) : focusedAddonPos,
      }
    case FETCH_DEVICE_ADDONS_SUCCESS:
      return {
        ...state,
        addons: [...action.payload.addons, ...state.addons],
      }
    case FETCH_PREMIUM_ADDONS_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage:
          action.payload instanceof Error && action.payload.message !== ''
            ? action.payload.message
            : 'An error occurred while trying to load premium addons',
      }
    case FETCH_DEVICE_ADDONS_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage:
          action.payload instanceof Error && action.payload.message !== ''
            ? action.payload.message
            : 'An error occurred while trying to load device addons',
      }
    case FETCH_ADDON_REQUEST:
      const addon = state.addons.find(
        addon => addon.id === action.payload.id && addon.itemType === 'premium'
      )
      if (addon === undefined) {
        return state
      }
      const addonPos = state.addons.indexOf(addon)
      return {
        ...state,
        addons: state.addons.map((addon, index) => {
          if (index === addonPos) {
            return {
              ...addon,
              detailsRequested: true,
            }
          }
          return {
            ...addon,
          }
        }),
      }
    case FETCH_ADDON_DETAILS_SUCCESS:
      const addonDetails = state.addons.find(
        addon => addon.id === action.payload.id && addon.itemType === 'premium'
      )
      if (addonDetails === undefined) {
        return state
      }
      const addonDetailsPos = state.addons.indexOf(addonDetails)
      return {
        ...state,
        addons: state.addons.map((addon, index) => {
          if (index === addonDetailsPos) {
            return {
              ...addon,
              description: action.payload.description,
            }
          }
          return {
            ...addon,
          }
        }),
      }
    case FETCH_ADDON_VIDEOS_SUCCESS:
      const addonVideos = state.addons.find(
        addon => addon.id === action.payload.id && addon.itemType === 'premium'
      )
      if (addonVideos === undefined) {
        return state
      }
      const addonVideosPos = state.addons.indexOf(addonVideos)
      return {
        ...state,
        addons: state.addons.map((addon, index) => {
          if (index === addonVideosPos) {
            return {
              ...addon,
              items: action.payload.items,
            }
          }
          return {
            ...addon,
          }
        }),
      }
    case FETCH_ADDON_VIDEOS_FAILURE:
      const addonVideosFailure = state.addons.find(
        addon => addon.id === action.payload.id && addon.itemType === 'premium'
      )
      if (addonVideosFailure === undefined) {
        return state
      }
      const addonVideosFailurePos = state.addons.indexOf(addonVideosFailure)
      return {
        ...state,
        addons: state.addons.map((addon, index) => {
          if (index === addonVideosFailurePos) {
            return {
              ...addon,
              items: [],
            }
          }
          return {
            ...addon,
          }
        }),
      }
    case SELECT_ADDON_SUCCESS:
      const selectedAddonId = parseInt(action.payload.addon.id, 10)
      const selectedAddon = state.addons.find(
        addon =>
          addon.id === selectedAddonId && addon.itemType === action.payload.addon.itemType
      )
      if (selectedAddon === undefined) {
        return state
      }
      const selectedAddonPos = state.addons.indexOf(selectedAddon)
      return {
        ...state,
        previousAddonPos: selectedAddonPos,
        focusedAddonPos: -1,
        focusDetails: false,
        addons: state.addons.map((addon, index) => {
          if (index === selectedAddonPos) {
            return {
              ...addon,
              isSelected: true,
            }
          }
          return {
            ...addon,
          }
        }),
      }
    case SELECT_ADDON_FAILURE:
      return {
        ...state,
        hasError: true,
        errorMessage:
          action.payload instanceof Error && action.payload.message !== ''
            ? action.payload.message
            : 'An error occurred while trying to select the addon',
      }
    case FOCUS_ADDON:
      return {
        ...state,
        focusedAddonPos: action.payload.position,
        previousAddonPos:
          state.focusedAddonPos !== -1 ? state.focusedAddonPos : state.previousAddonPos,
        focusDetails: false,
      }
    case FOCUS_DETAILS:
      return {
        ...state,
        focusDetails: true,
        focusedAddonPos: -1,
        previousAddonPos:
          state.focusedAddonPos !== -1 ? state.focusedAddonPos : state.previousAddonPos,
      }
    case DISMISS_ERROR:
      return {
        ...state,
        hasError: false,
        errorMessage: '',
      }
    case FETCH_CART_ITEMS_SUCCESS:
      return {
        ...state,
        addons: state.addons.map((addon, index) => {
          const addOnInCart = action.payload.items.find(
            item => item.itemId === addon.id && item.itemType === addon.itemType
          )
          return {
            ...addon,
            isSelected: addOnInCart !== undefined,
          }
        }),
      }
    case REMOVE_ADDON_REQUEST:
      const addonRemove = state.addons.find(
        addon => addon.id === action.payload.id
      )
      if (addonRemove === undefined) {
        return state
      }
      const addonPositionRemove = state.addons.indexOf(addonRemove)
      return {
        ...state,
        addons: state.addons.map((addon, index) => {
          if (index === addonPositionRemove) {
            return {
              ...addon,
              isSelected: false
            }
          }
          return {
            ...addon,
            
          }
        }),
      }

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case PAY_NOW_SUCCESS:
    case SELECT_PACKAGE_SUCCESS:
    case DISMISS_ERROR:
    case RESET:
      return {
        ...INITIAL_STATE,
      }

    default:
      return state
  }
}

export default addonsReducer
